export interface Extension {
  id: string,
  send: <T>(extensionId: string, payload: any) => Promise<T>,
}

export interface basicResponse {
  result: string,
}

export interface infoResponse extends basicResponse {
  email?: string,
  // eslint-disable-next-line camelcase
  is_locked?: boolean,
  name?: string,
  photo?: string,
}

export interface accessResponse extends basicResponse {
  session: string,
}

export const durtStatus = {
  loggedIn: 'LOGGED_IN',
  locked: 'LOCKED',
  notRegistered: 'USER_NOT_REGISTERED',
};

export const durtApiResponseType = {
  notSupportedError: 'NOT_SUPPORTED_ERROR',
  success: 'SUCCESS',
  unexpecedError: 'UNEXPECTED_ERROR',
  userNotRegisteredError: 'USER_NOT_REGISTERED_ERROR',
};

export const command = {
  access: 'access',
  info: 'info',
  logout: 'logout',
  register: 'register',
};

export const extensionResponseType = {
  commandNotFound: 'COMMAND_NOT_FOUND',
  messagingError: 'NATIVE_MESSAGING_ERROR',
  success: 'SUCCESS',
  unxepectedError: 'BE_UNEXPECTED_ERROR',
};

export const durtOidcScopes = [
  'device',
  'email',
  'openid',
  'organization',
  'profile',
];
